export const MAX_APPLICATION_NAME_LENGTH = 100;
